// extracted by mini-css-extract-plugin
module.exports = {"memberCol":"ProductList_memberCol_tc7Oj"};